
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/provereni-rizikovosti-osob",
      function () {
        return require("private-next-pages/provereni-rizikovosti-osob/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/provereni-rizikovosti-osob"])
      });
    }
  